import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { parentalApi } from '../api/parental.api'
import type { RestrictionsPayload } from '../types'

export const CHILDREN_KEY = ['parental', 'children'] as const

export function useLinkedChildren() {
  return useQuery({
    queryKey: CHILDREN_KEY,
    queryFn: () => parentalApi.fetchChildren().then((r) => r.data.data),
  })
}

export function useChildDashboard(childId: string | null) {
  return useQuery({
    queryKey: [...CHILDREN_KEY, childId, 'dashboard'],
    queryFn: () => parentalApi.fetchChildDashboard(childId ?? '').then((r) => r.data.data),
    enabled: childId !== null,
  })
}

export function useChildRestrictions(childId: string | null) {
  return useQuery({
    queryKey: [...CHILDREN_KEY, childId, 'restrictions'],
    queryFn: () => parentalApi.fetchRestrictions(childId ?? '').then((r) => r.data.data),
    enabled: childId !== null,
  })
}

export function useUpdateRestrictions(childId: string | null) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (payload: RestrictionsPayload) =>
      parentalApi.updateRestrictions(childId ?? '', payload).then((r) => r.data.data),
    // Les restrictions s'appliquent aux sessions futures : le tableau de bord
    // de l'enfant est relu en même temps.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: CHILDREN_KEY }),
  })
}
